// extracted by mini-css-extract-plugin
export default {"container":"sA921fE8C3","message":"VtkO2nol4B"};